var arrLeonardGTMTrackingFormPath = [
  "/obtenir-une-evaluation/",
  "/en/get-a-quote/",
  "/demande-information/",
  "/en/request-more-information/",
  "/contact/contactez-nous/",
  "/en/contact/contact-us/",
]

var arrLeonardGTMTrackingFormPathGtm3 = [
  "/carrieres/",
  "/en/careers/",
]

var arrLeonardGTMTrackingFormPathGtm4 = [
  "/espace-client/",
  "/en/customer-area/",
]

var arrLeonardGTMTrackingFormPathGtm4form = [
  "/espace-client/inscription-a-lespace-client/",
  "/en/customer-area/customer-zone-registration/",
  "/en/customer-area/connexion/",
  "/espace-client/connexion/",
]

var arrLeonardGTMTrackingFormPathGtm6 = [
  "/produits/",
  "/en/products/",
]
$(document).ready(function(){
    mainMenu();
    nonBreakSpace();

    initLeonardGTMTracking();
    scroll();
    $(window).scroll(function (event) {
        scroll();
    });

    fancyboxVideo()

    if ($('.list_container').length > 0 && $('.map_container').length > 0) {
		manageMap();
    }

    if ($('section.blog').length) {
		blog();
    }

    if ($('section.form').length) {
        form();
        manageMap();
    }

    if ($('section.careers').length) {
		$('.breadcrumbs').addClass('black-breadcrumb');
    }

    if ($('section.career_banner').length) {
		$('.breadcrumbs').addClass('white-breadcrumb');
    }

    if ($('section.career_testimonies_slider').length) {
		careerTestimonies();
    }

    if ($('section.experience-slider').length) {
		experienceSlider();
    }

    if ($('section.values').length) {
		valuesSlider();
    }

    if ($('section.gallery').length) {
		gallery();
    }

    if ($('section.slider .bloc_container').length) {
		slider();
    }

    if ($('section.testimonies').length) {
		testimony();
    }

    if ($('section.testimonies_big').length) {
        testimonyBig();
    }

    if ($('section.trucks').length) {
		trucks();
    }

    if ($('section.why').length) {
        why();
    }

    $('.show_more_btn').on('click', function() {
        $('.benefits_container').toggleClass('show_all');
    
        if ($('.benefits_container').hasClass('show_all')) {
            if ($('html')[0].lang == 'en') {
                $('.show_more_btn .description').text('Show less.');
            } else {
                $('.show_more_btn .description').text('Voir moins.');
            }
        } else {
            if ($('html')[0].lang == 'en') {
                $('.show_more_btn .description').text('Show more...');
            } else {
                $('.show_more_btn .description').text('Voir plus...');
            }
        }
    });

    // contact form redirection
	document.addEventListener( 'wpcf7mailsent', function( event ) {
		$redirectUrl = $('input[name=redirect_url]').val();
		if($redirectUrl != undefined){
		  location = $redirectUrl;
		}
	}, false );
});

function blog() {
    var url = 'blogue';
    if (document.documentElement.lang == 'en') {
        url = 'en/blog';
    }
    $("select").chosen({
        disable_search_threshold: 10,
        width: "235px",
	}).change( function() {
        window.location.href = '/' + url + '/' + $(this).val();
	});
}

function fancyboxVideo() {
    $('span.fancybox.video').click(function (e) {
        var url = $(this).attr( "data-url" );

        $.fancybox.open({
            src : url,
            type : 'iframe'
        });

        return false;
    });
}

function form() {
    $("select").chosen({
        width: "100%",
	});
}

function careerTestimonies(){
    $('.career_testimonies_slider .box_container').slick({
        arrows:true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
        ]
      });
}

function valuesSlider(){
    $('.values .values_container').slick({
        arrows:true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
        ]
      });
}

function experienceSlider(){
    $('.experience-slider .box_container').slick({
        arrows:true,
        infinite: true,
        centerMode: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
        ]
      });
}

function gallery() {
    var toshow = 11;
    var centerMode = false;
    var variableWidth = false;


    if ($("section.gallery").hasClass("text")) {
        toshow = 1;
        centerMode = true;
        variableWidth = true;
    }

    $('.gallery .main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.gallery .nav'
    });

    $('.gallery .nav').slick({
        slidesToShow: toshow,
        centerMode: centerMode,
        variableWidth: variableWidth,
        slidesToScroll: 1,
        asNavFor: '.gallery .main',
        focusOnSelect: true,

        responsive: [
            {
                breakpoint: 1249,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });

    $('.companies_container .bloc').on('click', function() {
        var company = $(this).attr('data-company');

        $('.companies_container .bloc').removeClass('active');
        $(this).addClass('active');

        // remove
        $('.main .bloc').each(function () {
            $('.gallery .main').slick('slickRemove', $(this).attr('data-slick-index'));
            // manually delete the last one cauz we can't remove all the slides with just the first line
            $('.gallery .main').slick('slickRemove', 0);
        });

        $('.nav .img_container').each(function () {
            $('.gallery .nav').slick('slickRemove', $(this).attr('data-slick-index'));
            // manually delete the last one cauz we can't remove all the slides with just the first line
            $('.gallery .nav').slick('slickRemove', 0);
        });

        // add
        $('.main_clone .bloc').each(function() {
            if ($(this).hasClass(company)) {
                $('.gallery .main').slick('slickAdd', $(this)[0].outerHTML);
            }
        });

        $('.nav_clone .img_container').each(function() {
            if ($(this).hasClass(company)) {
                $('.gallery .nav').slick('slickAdd', $(this)[0].outerHTML);
            }
        });
    });
}

function mainMenu() {
	// open/close menu in mobile
    $('.toggle-menu').click(function () {
        if (!$('header').hasClass('sticky')) {
            $(window).scrollTop(0);
        }

        $('html').toggleClass('open');
        $(this).toggleClass('open');
        $('.main_menu_container').toggle();
    });

    // block click on parent item on mobile
    if (isMobileWidth()) {        
        $('.main_menu_container .menu > .parent > a').click(function (e) {
            if ($(this).parent().hasClass('active')) {
				$(this).parent().removeClass('active');
			} else {
				$(this).parent().addClass('active');
			}

			var id = $(this).parent().attr('id');

			$(".main_menu_container .menu > .parent ").each(function () {
				if ($(this).attr('id') != id) {
					$(this).removeClass('active');
				}
            });

            e.preventDefault();
        })

        $('.mobile-lang-menu li.wpml-ls-current-language > a').click(function (e) {
            e.preventDefault();
        })
    }
}

function manageMap() {
    $(".list_container .bloc").mouseenter(function () {
        var id = $(this).attr("id")
        $(".list_container .bloc").removeClass('active');

        $.each(map.markers, function(i, marker){
            marker.setIcon('/wp-content/themes/simard-theme/images/icon/marker.png');

            if (marker.id == id) {
                marker.setIcon('/wp-content/themes/simard-theme/images/icon/marker_active.png');
            }
        });
    })

    $(".list_container .bloc").mouseleave(function () {
        $.each(map.markers, function( i, marker ){
            marker.setIcon('/wp-content/themes/simard-theme/images/icon/marker.png');
        });
    })
}

function nonBreakSpace() {
    if (!isMobileWidth()) {
        $("body p, body span, body h1, body h2, body h3, body h4, body h5, body li").html(function(index, text) {
            return text.replace('Simard Suspensions', 'Simard&nbsp;Suspensions');
        });
    }
}

function scroll() {
    var lastScrollTop = 0;


    var st = $(this).scrollTop();
    // downscroll
    if (st > lastScrollTop){
        if (st >= 150 && st < 175) {
            $('header').addClass('invisible');
        }
        if (st >= 175) {
            $('header').addClass('sticky');
        }
    // upscroll
    } else {
        if (st <= 150) {
            $('header').removeClass('sticky').removeClass('invisible');
        }
    }
    lastScrollTop = st;
}

function slider() {
    $('section.slider .bloc_container').slick({
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 10000,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
}

function testimony() {
    if ($('section.testimonies.slider1 .box_container .box').length >3) {
        $('section.testimonies.slider1 .box_container').slick({
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1249,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }

    if ($('section.testimonies.slider1 .box_container .box').length == 0) {
        $('section.testimonies.slider').hide();
    }
}

function testimonyBig() {
    var section = $('section.testimonies_big .slider_container');
    section.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        //adaptiveHeight: true,
        //centerMode: true,
        //variableWidth: true
    });

    section.on('beforeChange', function(){
        $('section.testimonies_big a.all').css('z-index', -1);
    });
    section.on('afterChange', function(){
        setTimeout(
        function()
        {
            $('section.testimonies_big a.all').css('z-index', 0);
        }, 1000);
    });

    section.mousedown(function() {
        console.log('test')
        $('section.testimonies_big a.all').css('z-index', -1);
    });
    section.mouseup(function() {
        $('section.testimonies_big a.all').css('z-index', 0);
    });
}

function trucks() {
    if (isMobileWidth()) {
        $('section.trucks .bloc_container').slick({
            centerMode: true,
            centerPadding: '60px',
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }
}

function why() {
    // accordion
    if (isMobileWidth()) {
        $('.why').find('.toggle').click(function(){
            // Expand or collapse this panel
            $(this).toggleClass('open').next().slideToggle('fast');

            // Hide the other panels
            $(".why .toggle").not($(this)).removeClass('open');
            $(".why .text_container").not($(this).next()).slideUp('fast');
        });
    }
}

function isMobileWidth() {
    return $('#mobile-indicator').is(':visible');
}


function initLeonardGTMTracking() {
  // Track CTA pointing to a «Leads Form»
  // -------
  var arrLeonardGTMTrackingCTA = [];
  for(var i=0; i<arrLeonardGTMTrackingFormPath.length; i++){
    arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
  }

  // Custom CSS rules here
  // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

  $(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

  // Track «Leads form» submit button click
  // -------

  if(arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
    $("form button, form input[type=submit]").addClass("gtm-form-submited");
    $("form#mc4wp-form-1 button, form#mc4wp-form-1 input[type=submit]").removeClass("gtm-form-submited");
  }

  //Newsletter
  $('.newsletter_container form').addClass('gtm-form-newsletter');

  //Breadcrumbs
  $('.breadcrumbs').addClass('gtm-breadcrumbs');

  //gmt-1
  $('.home .trucks .bloc_container .btn').addClass('gtm-cta-1');

  //gmt-2
  $('.single .cta .btn_container').addClass('gtm-cta-2');
  if(arrLeonardGTMTrackingFormPathGtm3.indexOf(window.location.pathname) != -1) {
    $(".wysiwyg .btn").addClass("gtm-cta-2");
  }

  //gmt-3
  $('.menu .client a').addClass('gtm-cta-3');
  if(arrLeonardGTMTrackingFormPathGtm4.indexOf(window.location.pathname) != -1) {
    $(".btn").addClass("gtm-cta-3");
    $(".btn.transparent").removeClass("gtm-cta-3");
  }
  if(arrLeonardGTMTrackingFormPathGtm4form.indexOf(window.location.pathname) != -1) {
    $("form input[type=submit]").addClass("gtm-cta-3");
  }

  //gmt-4
  $('.home .testimonies_big .btn.transparent').addClass('gtm-cta-4');

  //gtm-5
  var arrLeonardGTMTrackingCTA2 = [];
  for(var i=0; i<arrLeonardGTMTrackingFormPathGtm6.length; i++){
    arrLeonardGTMTrackingCTA2.push("a.btn[href*='" + arrLeonardGTMTrackingFormPathGtm6[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPathGtm6[i] + "']");
  }

  $(arrLeonardGTMTrackingCTA2.join(", ")).addClass("gtm-cta-5");
}
(function ($) {
    /*
     *  new_map
     *
     *  This function will render a Google Map onto the selected jQuery element
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$el (jQuery element)
     *  @return	n/a
     */

    function new_map($el) {

        // var
        var $markers = $el.find('.marker');

        // vars
        var args = {
            zoomControl: true,
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true
        };

        // create map
        var map = new google.maps.Map($el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        var i = 0;
        $markers.each(function () {

            add_marker($(this), map, i);
            i++;
        });

        // center map
        center_map(map);

        // return
        return map;
    }

    /*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$marker (jQuery element)
     *  @param	map (Google Map object)
     *  @return	n/a
     */

    function add_marker($marker, map, i) {

        // var
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        var icon = '/wp-content/themes/simard-theme/images/icon/marker.png';

        if ($('.acf-map').hasClass('iconBigger')) {
            icon = {
                url: '/wp-content/themes/simard-theme/images/icon/marker.png',
                scaledSize: new google.maps.Size(25.71, 30)
            };
        }
        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: icon,
            id: 'id' + i
        });

        // add to array
        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function () {
                $(".list_container .bloc").removeClass('active');
                var bloc = $(".list_container #" + $marker.attr('data-id'));
                bloc.addClass('active');

                $('html,body').animate({
                    scrollTop: bloc.offset().top - 250
                }, 'slow');

                $.each(map.markers, function (i, marker) {
                    if (marker.id == $marker.attr('data-id')) {
                        marker.setIcon('/wp-content/themes/simard-theme/images/icon/marker_active.png');
                    } else {
                        marker.setIcon('/wp-content/themes/simard-theme/images/icon/marker.png');
                    }
                });

                //infowindow.open( map, marker );
            });
        }
    }

    /*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	map (Google Map object)
     *  @return	n/a
     */

    function center_map(map) {

        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else if (map.markers.length == 2) {
            map.setCenter(bounds.getCenter());
            map.setZoom(3.5);
        } else {
            // fit to bounds
            // map.setCenter( bounds.getCenter() );
            // map.setZoom(4.5); // Change the zoom value as required
            map.fitBounds(bounds); // This is the default setting which I have uncommented to stop the World Map being repeated
        }

    }

    /*
     *  document ready
     *
     *  This function will render each map when the document is ready (page has loaded)
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	5.0.0
     *
     *  @param	n/a
     *  @return	n/a
     */
    // global var
    window.map = null;

    jQuery(document).ready(function ($) {
        $('.acf-map').each(function () {
            // create map
            map = new_map($(this));
        });
    });

})(jQuery);
$(document).ready(function(){
    if ($('body').hasClass('page-id-5175') || $('body').hasClass('page-id-5180')) {
        $('.main-content section, .breadcrumbs').css("visibility", "hidden");

        var warning = "Veuillez entrer le mot de passe pour vous connecter à l'intranet.";

        if ($('html').attr('lang') == 'en') {
            warning = "Please enter the password to connect to the intranet.";
        }
        
        $('.main-content').before('<p class="warning" style="margin: 40px auto 0 auto;display: block;text-align: center;">' + warning + '</p>')
        $('.main-content').before('<input style="display: block; font-size: 20px; height: 50px; margin: 30px auto; padding: 10px; width: 400px;" type="text" id="password" name="password">');
    }

    $(document).on("keyup change", "input#password", function(){
        validatePassword(this.value);  
    });

    function validatePassword(val) {
        if (val == 'Simard2020') {
            $('.main-content section, .breadcrumbs').css("visibility", "visible"); 
            $('.warning, input#password').hide();
        }
    }
});